import AuthAPI from '~/api/auth';
import user from '~/api/user';

export default function ({ store, route, redirect }) {
  const data = route.query?.data;

  if (route.query?.from === 'admin') {
    if (data) {
      const jsonObj = JSON.parse(data);

      if (jsonObj.token && jsonObj.refresh_token && jsonObj.id) {
        const { token, refresh_token, user_id } = jsonObj;

        AuthAPI.setToken(token);
        if (process.browser) {
          localStorage.setItem('admin', 'logged in');
          localStorage.setItem('userId', user_id);
          localStorage.setItem('token', token);
          localStorage.setItem('refresh_token', refresh_token);
          store.dispatch('auth/setUser', { user_id });
          store.dispatch('cart/addActiveCart');
        }

        return redirect('/');
      }
    }
  }
}
